export default __webpack_public_path__ + "static/media/spotify.303ff8cd.png";